import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils.js';

export function Card({
  className,
  ...props
}: ComponentProps<'div'>): React.ReactNode {
  return (
    <div
      data-slot="card"
      className={cn(
        'flex flex-col gap-4 rounded-xl border border-border bg-card text-card-foreground shadow-elev-1',
        'transition-shadow duration-base ease-out',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({
  className,
  ...props
}: ComponentProps<'div'>): React.ReactNode {
  return (
    <div
      data-slot="card-header"
      className={cn(
        '@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6',
        className,
      )}
      {...props}
    />
  );
}

export function CardTitle({
  className,
  children,
  ...props
}: ComponentProps<'h3'>): React.ReactNode {
  return (
    <h3
      data-slot="card-title"
      className={cn(
        'font-heading text-lg font-semibold leading-tight tracking-tight',
        className,
      )}
      {...props}
    >
      {children}
    </h3>
  );
}

export function CardDescription({
  className,
  ...props
}: ComponentProps<'p'>): React.ReactNode {
  return (
    <p
      data-slot="card-description"
      className={cn('text-sm text-muted-foreground', className)}
      {...props}
    />
  );
}

export function CardAction({
  className,
  ...props
}: ComponentProps<'div'>): React.ReactNode {
  return (
    <div
      data-slot="card-action"
      className={cn(
        'col-start-2 row-span-2 row-start-1 self-start justify-self-end',
        className,
      )}
      {...props}
    />
  );
}

export function CardContent({
  className,
  ...props
}: ComponentProps<'div'>): React.ReactNode {
  return (
    <div
      data-slot="card-content"
      className={cn('px-6 [&:last-child]:pb-6', className)}
      {...props}
    />
  );
}

export function CardFooter({
  className,
  ...props
}: ComponentProps<'div'>): React.ReactNode {
  return (
    <div
      data-slot="card-footer"
      className={cn('flex items-center px-6 pb-6 [.border-t]:pt-6', className)}
      {...props}
    />
  );
}
